import axios from 'axios';

const loadAbort = () => {
  return new AbortController();
};

export const anulatePaymentEndpoint = (
  transactionDetailId: string,
  token: string,
) => {
  const controller = loadAbort();

  return {
    call: (urlService: string) =>
      axios({
        method: 'put',
        url: `${urlService}/ts/v1/admin/transaction-detail/${transactionDetailId}/anulate`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};
